var _ = require('underscore');
var Marionette = require('marionette');
var Validation = require('validation');
var Behaviors = require('Behaviors');
var Dialog = require('Dialog');
var DialogConfirmation = require('DialogConfirmation');
var DialogWarning = require('DialogWarning');
var Dropdown = require('Dropdown');
var Entities = require('Entities');
var Grid = require('Grid');
var Labels = EY.Consultation.Labels;
var Logger = require('Logger');
var Lookups = EY.Consultation.Lookups;
var Resources = EY.Consultation.Resources;
var StatusType = EY.Consultation.Lookups.StatusType;
var User = EY.Consultation.CurrentUser;
var Geographies = new Entities.Geographies(Resources.Geography);
var Roles = new Entities.Roles(_.sortBy(Resources.Roles, 'order'));
var SubcountriesByParent = _.chain(Resources.Geography).filter({ type: 'SubCountry' }).groupBy('parentId').value();

var update = function (upn, roles, geography) {
    var records = new Entities.Records();
    var filter = _.extend({ approval: '', upn: upn, approverGroupId: { $regex: roles } }, geography);
    records.fetch({ filter: { statusTypeId: { $nin: [StatusType.Complete, StatusType.UsersNotified]}, approvers: { $elemMatch: filter } } }).done(function () {
        records.each(function (record) {
            var api = Lookups.RedBoxCountryApi[record.get('countryId')];

            if (api) {
                record.urlRoot = api + 'Record';
            }
            if (record.get('assignedTo') === upn) {
                record.set('assignedTo', '');
                record.set('assignedToGivenName', '');
            }
            _.chain(record.get('approvers')).filter({ upn: upn, approval: '' }).each(function (approver) {
                approver.displayName = '';
                approver.givenName = '';
                approver.email = '';
                approver.upn = '';
                approver.rank = '';
                // To retain the approverGroupId when we deactivate the user
                if (record.get('assignedTo') == '') {
                    record.set('assignedToApproverGroupId', approver.approverGroupId);
                }
            }).value();
            record.save({}, { validate: false });
        });
    });
};

var validation = function () {
    return {
        path: function (pattern, label) {
            var geographyTypePath = this.get('geographyTypePath');
            var regex = new RegExp(pattern);
            var role = Roles.get(this.get('roleId'));

            if (!role || (role.get('geographyRequired') && regex.test(role.get('geographyTypePath')) && !regex.test(geographyTypePath))) {
                return Labels.ErrorMsg.replace('{0}', label);
            }
        },
        validation: {
            areaId: function () { return this.path('/Area/', Labels.Area); },
            countryId: function () {
                var geographyId = new RegExp(this.get('geographyId'));

                return _.some(_.keys(SubcountriesByParent), function (key) { return geographyId.test(key); }) ? this.path('/Area/Region/Country/', Labels.Country) : this.path('/Area/Region/Country/$', Labels.Country);
            },
            roleId: { required: true, msg: Labels.ErrorMsg.replace('{0}', Labels.Role) },
            regionId: function () { return this.path('/Area/Region/', Labels.Region); },
            subcountryId: function () {
                var geographyId = new RegExp(this.get('geographyId'));
                var role = Roles.get(this.get('roleId'));
                var isSubcountryRequired = role && /SubCountry/.test(_.first(role.get('geographyTypePath').split('|')));

                return _.some(_.keys(SubcountriesByParent), function (key) { return geographyId.test(key); }) || isSubcountryRequired ? this.path('/Area/Region/Country/SubCountry/$', Labels.Region) : '';
            }
        }
    };
};

var Layout = Marionette.View.extend({
    behaviors: [Behaviors.Tooltip],
    events: {
        'click @ui.status': 'status'
    },
    regions: {
        grid: '#roleGrid',
        role: '#role'
    },
    template: '#userProfile',
    ui: {
        displayName: '#displayName',
        status: '#status'
    },
    onRender: function () {
        var geographies = this.options.roles.findWhere(function (role) {
            return new RegExp(User.geography).test(role.get('geographyId')) || (!Roles.get(role.get('roleId')).get('geographyRequired') && new RegExp(User.adminGeographyTypePath).test('^/Area/$'));
        });

        if (this.options.roles.length > 0 && !geographies) {
            this.ui.status.attr("disabled", 'disabled');
        }
        if (!User.adminRoles) {
            this.$('input,button,a').attr('disabled', 'disabled').addClass('disabled');
        }
        if (this.model.get('givenName') === this.model.get('displayName')) {
            this.ui.displayName.addClass('hidden');
        }
        this.ui.status.attr("checked", this.model.get('active'));
    },
    status: function (e) {
        if (!e.target.checked) {
            context = this;
            DialogConfirmation.show({
                message: Labels.MSG024
            }).done(function () {
                context.model.set('active', e.target.checked);
                context.options.roles.reset();
                context.model.save();
                update(context.model.get('upn'), _.pluck(_.reject(Resources.ApproverGroup, { roleId: '' }), 'id').join('|'));
            }).fail(function () {
                e.target.checked = true;
            });
        } else {
            this.model.set('active', e.target.checked);
            this.options.roles.reset(activeRoles(this.model.get('roles')) || []);
            this.model.save();
        }
    }
});

var RoleView = Marionette.View.extend({
    events: {
        'blur @ui.specialty': function () { this.model.set('specialty', _.escape(this.ui.specialty.val())); },
        'click @ui.add': 'add'
    },
    regions: {
        area: '#area',
        country: '#country',
        region: '#region',
        role: '#role',
        subcountry: '#subcountry'

    },
    template: '#userProfileAddRole',
    ui: {
        add: '#add',
        region: '#regionContainer',
        specialty: '#specialty',
        subcountry: '#subcountryContainer'
    },
    initialize: function () {
        var context = this;
        Validation.bind(this, {
            attributes: ['roleId', 'areaId', 'regionId', 'countryId', 'subcountryId']
        });
        this.options.user.on('change:active', function (user) {
            context.ui.add.attr('disabled', !user.get('active'));
        });
    },
    onRender: function () {
        if (!User.adminRoles) {
            this.$('button').attr('disabled', 'disabled').addClass('disabled');
        }
        if(!this.options.user.get('active')){
            this.ui.add.attr('disabled', true);
        }
    },
    add: function () {
        if (this.model.isValid()) {
            if (!this.collection.findWhere({ roleId: this.model.get('roleId'), geographyId: this.model.get('geographyId') })) {

                this.model.set('modifiedBy', EY.Consultation.CurrentUser.upn);
                this.model.set('modifiedOn', new Date());
                this.model.set('status', 'Active');
                this.collection.add(this.model.clone());
                this.options.user.save({
                    roles: this.collection.toJSON(),
                    geography: _.chain(this.collection.toJSON()).pluck('geographyId').uniq().value().join('|')
                });
                var user = this.options.user;
                Logger.logToServer(JSON.stringify({
                    currentUser: EY.Consultation.CurrentUser.upn,
                    changedProfile: user.id,
                    addedRole: this.model.attributes
                }), 'newRoleAdded');
            } else {
                DialogWarning.show({
                    message: Labels.MSG025
                });
            }
        }
    }
});

var Delete = Marionette.View.extend({
    events: {
        'click @ui.action': 'action'
    },
    tagName: 'td',
    template: '#userProfileGridDeleteAction',
    ui: {
        action: '#action'
    },
    onRender: function () {
        var allow = new RegExp(User.adminGeography).test(this.model.get('geographyId'))
            || (new RegExp(User.adminGeographyTypePath).test('^/Area/$') && !Roles.get(this.model.get('roleId')).get('geographyRequired'));

        if (allow) {
            this.ui.action.add();
        } else {
            this.ui.action.remove();
        }
    },
    action: function () {
        var context = this;
        DialogConfirmation.show({
            message: Labels.MSG029
        }).done(function () {
            context.model.collection.remove(context.model);
            var user = context.options.column.get('user');
            var roles = user.get('roles');
            var deletedRoles = user.get('deletedRoles');
            var updatedRoles = _.reject(roles, function (role) {
                return role.geographyId === context.model.get('geographyId') && role.roleId === context.model.get('roleId');
            });
            deletedRoles.push({
                ...context.model.attributes,
                status: 'Removed',
                modifiedBy: EY.Consultation.CurrentUser.upn,
                modifiedOn: new Date()
            });
            user.save({
                roles: updatedRoles,
                deletedRoles: deletedRoles,
                geography: _.chain(updatedRoles).pluck('geographyId').uniq().value().join('|')
            });
            var group = _.findWhere(EY.Consultation.Resources.ApproverGroup, { roleId: context.model.get('roleId'), geographyTypePath: context.model.get('geographyTypePath') });
            if (group) {
                update(user.get('upn'), group.id, { geographyId: context.model.get('geographyId') });
            }
            Logger.logToServer(JSON.stringify({
                currentUser: EY.Consultation.CurrentUser.upn,
                changedProfile: user.id,
                deletedRole: context.model.attributes
            }), 'removeRole');
        });
    }
});

var EditView = Marionette.View.extend({
    ui: {
        specialty: '#specialty',
        role: '#role',
        area: '#area',
        region: '#region',
        country: '#country',
        subcountry: '#subcountry'
    },
    onRender: function () {
        var id = this.model.get('geographyId').slice(1, -1);
        var areaIndex = this.model.get('geographyTypePath').slice(1, -1).toLowerCase().split('/').indexOf("area");
        var regionIndex = this.model.get('geographyTypePath').slice(1, -1).toLowerCase().split('/').indexOf("region");
        var countryIndex = this.model.get('geographyTypePath').slice(1, -1).toLowerCase().split('/').indexOf("country");
        var subcountryIndex = this.model.get('geographyTypePath').slice(1, -1).toLowerCase().split('/').indexOf("subcountry");
        
        this.ui.area.val(id && areaIndex > -1 ? Geographies.get('/' + _.take(id.split('/'), areaIndex + 1).join('/') + '/').get('text') : '');
        this.ui.region.val(id && regionIndex > -1 ? Geographies.get('/' + _.take(id.split('/'), regionIndex + 1).join('/') + '/').get('text') : '');
        this.ui.country.val(id && countryIndex > -1 ? Geographies.get('/' + _.take(id.split('/'), countryIndex + 1).join('/') + '/').get('text') : '');
        this.ui.subcountry.val(id && subcountryIndex > -1 ? Geographies.get('/' + _.take(id.split('/'), subcountryIndex + 1).join('/') + '/').get('text') : '');
        this.ui.role.val(Labels['Role_' + this.model.get('roleId')]);
        this.ui.specialty.val(_.unescape(this.model.get('specialty')));
    },
    saveSpecialty: function () {
        this.model.set('specialty', _.escape(this.ui.specialty.val()));
    },
    template: '#editSpecialityView'
});

var Edit = Marionette.View.extend({
    events: {
        'click @ui.action': 'action'
    },
    tagName: 'td',
    template: '#userProfileGridEditAction',
    ui: {
        action: '#action'
    },
    onRender: function () {
        var allow = new RegExp(User.adminGeography).test(this.model.get('geographyId'))
            || (new RegExp(User.adminGeographyTypePath).test('^/Area/$') && !Roles.get(this.model.get('roleId')).get('geographyRequired'));

        if (allow) {
            this.ui.action.add();
        } else {
            this.ui.action.remove();
        }

    },
    action: function () {
        var context = this;
        var user = context.options.column.get('user');
        var editView = new EditView({
            model: context.model
        });
        Dialog.show({
            cancelLabel: Labels.Cancel,
            headerLabel: Labels.EditSpeciality,
            saveLabel: Labels.Save,
            view: editView
        }).done(function () {
            editView.saveSpecialty();
            context.model.set('modifiedBy', EY.Consultation.CurrentUser.upn);
            context.model.set('modifiedOn', new Date());

            user.save({
                roles: context.model.collection.toJSON(),
                geography: _.chain(context.model.collection.toJSON()).pluck('geographyId').uniq().value().join('|')
            });

            require('Consultation').showToast({ result: "success", text: Labels.SpecialitySaved});
            Logger.logToServer(JSON.stringify({
                currentUser: EY.Consultation.CurrentUser.upn,
                changedProfile: user.id,
                updatedRole: context.model.attributes
            }), 'specilaityUpdate');
        });
    }
});

var Geography = Marionette.View.extend({
    tagName: 'td',
    template: _.noop,
    onRender: function () {
        var id = this.model.get('geographyId').slice(1, -1);
        var index = this.model.get('geographyTypePath').slice(1, -1).split('/').indexOf(this.options.column.get('name'));

        this.$el.html(id && index > -1 ? Geographies.get('/' + _.take(id.split('/'), index + 1).join('/') + '/').get('text') : '');
    }
});

var Role = Marionette.View.extend({
    tagName: 'td',
    template: _.noop,
    onRender: function () {
        this.$el.html(Labels['Role_' + this.model.get('roleId')]);
    }
});

var Tooltip = Marionette.View.extend({
    behaviors: [Behaviors.TooltipGrid],
    className: 'string-cell sortable renderable tooltip-css',
    tagName: 'td',
    template: _.noop
});


var columns = function (options) {
    var user = options.user;
    return [
        { name: 'roleId', label: Labels.Role, editable: false, cell: Role },
        { name: 'specialty', label: Labels.Specialty, editable: false, cell: Tooltip },
        { name: 'Area', label: Labels.Area, editable: false, cell: Geography },
        { name: 'Region', label: Labels.Region, editable: false, cell: Geography },
        { name: 'Country', label: Labels.Country, editable: false, cell: Geography },
        { name: 'SubCountry', label: Labels.USRegion, editable: false, cell: Geography },
        { name: '', label: '', editable: false, cell: Edit, user: user, roles: new Backbone.Collection(user.get("roles"))},
        { name: '', label: '', editable: false, cell: Delete, user: user}
    ];
};

var grid = function (options) {
    var region = options.region;
    var roles = options.roles;
    Grid.show({
        collection: roles,
        columns: columns(options),
        region: region
    });
};

var roleView = function (options) {
    var region = options.region;
    var adminGeography = new RegExp(User.adminGeography);
    var adminGeographyTypePath = new RegExp(User.adminGeographyTypePath);
    var empty = new Entities.Roles();
    var geography = _.chain(Resources.Geography).uniq('type').pluck('type').reduce(function (memo, x) { memo[x] = new Entities.Geographies(); return memo; }, {}).value();
    var roles = new Entities.Roles(Roles.filter(function (role) {
        var geoTypePath = _.some(_.keys(SubcountriesByParent), function (key) { return adminGeography.test(key); }) ? role.get('geographyTypePath') : _.first(role.get('geographyTypePath').split('|'));
        var roleGeography = new RegExp(role.get('geography'));
        var SupportAdmin = new RegExp('SupportAdministrator');

        return adminGeographyTypePath.test(geoTypePath) && roleGeography.test(User.adminGeography) && !SupportAdmin.test(role.id);
    }));
    var userRole = _.extend(new Entities.Role(), validation());
    var view = new RoleView({
        collection: options.roles,
        model: userRole,
        user: options.user
    });

    region.show(view);
    Dropdown.show({
        collection: roles,
        readonly: !User.adminRoles,
        region: view.getRegion('role'),
        selection: -1,
        resourceKeyAffix: 'Role_',
        resourceKeyAttribute: 'id',
        onSelectionChanged: function (role) {
            var path = role.get('geographyTypePath');
            var subcountry = /SubCountry/.test(path);
            
            geography = _.mapObject(geography, function () { return new Entities.Geographies(); });
            if (role.id) {
                _.chain(Resources.Geography).filter(function (entry) {
                    var regex = new RegExp(entry.id);

                    return (regex.test(User.adminGeography) || adminGeography.test(entry.id))
                        ? subcountry && entry.type === 'Country' ? !!SubcountriesByParent[entry.id] : true
                        : false;
                }).groupBy('type').each(function (entries, key) {
                    geography[key].reset(entries);
                }).value();
            }

            userRole.set('roleId', role.id);
            Dropdown.show({
                collection: role.id ? geography.Area : empty,
                childCollection: geography.Region,
                readonly: (role.id && !role.get('geographyRequired')) || !User.adminRoles,
                region: view.getRegion('area'),
                onSelectionChanged: function (selection) {
                    userRole.set({
                        geographyId: role.get('geographyRequired') ? selection.id : '//',
                        geographyTypePath: selection.get('typePath')
                    });
                }
            });
            Dropdown.show({
                collection: role.id ? geography.Region : empty,
                childCollection: geography.Country,
                parentCollection: geography.Area,
                readonly: (path && path.indexOf('Region') == -1) || !User.adminRoles,
                region: view.getRegion('region'),
                onSelectionChanged: function (selection) {
                    userRole.set({
                        geographyId: role.get('geographyRequired') ? selection.id : '//',
                        geographyTypePath: selection.get('typePath')
                    });
                }
            });
            Dropdown.show({
                collection: role.id ? geography.Country : empty,
                parentCollection: geography.Region,
                readonly: (path && path.indexOf('Country') == -1) || !User.adminRoles,
                region: view.getRegion('country'),
                onSelectionChanged: function (selection) {
                    if (selection.id) {
                        if (SubcountriesByParent[selection.id]) {
                            view.ui.region.addClass('hidden');
                            view.ui.subcountry.removeClass('hidden');
                        }
                        userRole.set({
                            geographyId: role.get('geographyRequired') ? selection.id : '//',
                            geographyTypePath: selection.get('typePath')
                        });
                    }
                }
            });
            Dropdown.show({
                collection: role.id ? geography.SubCountry : empty,
                parentCollection: geography.Country,
                readonly: (path && path.indexOf('SubCountry') === -1) || !User.adminRoles,
                region: view.getRegion('subcountry'),
                onSelectionChanged: function (selection) {
                    if (selection.id) {
                        userRole.set({
                            geographyId: role.get('geographyRequired') ? selection.id : '//',
                            geographyTypePath: selection.get('typePath')
                        });
                    }
                }
            });
            view.ui.region.removeClass('hidden');
            view.ui.subcountry.addClass('hidden');
            view.ui.specialty.val('');
            userRole.set('specialty', '');
        }
    });
};

var start = function (options) {
    var consultation = require('Consultation');
    var model = options.user;
    var roles = options.roles;
    var layout = new Layout({
        model: model,
        roles: roles
    });

    consultation.show({ view: layout });
    grid(_.extend({}, options, {
        region: layout.getRegion('grid')
    }));
    roleView(_.extend({}, options, {
        region: layout.getRegion('role')
    }));
};

/// This function is used to remove roles which are
/// marked as removed from the main roles collection.
var activeRoles = function (roles) {
    return roles.filter(function (role) {
        return role.status !== Labels.Status_Removed;
    });
};

module.exports.start = function (options) {
    var user = options.user;
    var roles = user.get('active') ? activeRoles(user.get('roles')) : [];
    options.roles = new Entities.Roles(roles || []);
    start(options);
};


// WEBPACK FOOTER //
// ./js/Modules/User/UserProfile.js